module.exports = __webpack_public_path__ + "06d345d9e02fcd0e51fa891406be9d1c.png";